var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCodeBrackets = function SvgCodeBrackets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.91 2.03c.328.083.52.466.41.821L7.383 15.54c-.082.328-.465.52-.82.41a.653.653 0 0 1-.41-.82L10.09 2.44a.653.653 0 0 1 .82-.41Zm1.942 3.227c.246-.273.656-.273.93-.027l3.5 3.281c.136.11.218.301.218.465a.684.684 0 0 1-.219.492l-3.5 3.282a.677.677 0 0 1-.93-.028c-.246-.273-.246-.683.028-.93l2.98-2.816-2.98-2.789c-.274-.246-.274-.656-.027-.93Zm-8.23 0c.245.274.245.684-.028.93l-2.98 2.79 2.98 2.816c.273.246.273.656.027.93-.246.273-.656.273-.93.027l-3.5-3.282A.659.659 0 0 1 0 8.976c0-.164.055-.355.191-.465l3.5-3.28c.274-.247.684-.247.93.026Z"
  })));
};
export default SvgCodeBrackets;